"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllCultures = void 0;
const at_culture_1 = require("./at-culture");
const au_culture_1 = require("./au-culture");
const be_culture_1 = require("./be-culture");
const br_culture_1 = require("./br-culture");
const ca_culture_1 = require("./ca-culture");
const ch_culture_1 = require("./ch-culture");
const cl_culture_1 = require("./cl-culture");
const cn_culture_1 = require("./cn-culture");
const co_culture_1 = require("./co-culture");
const de_culture_1 = require("./de-culture");
const dk_culture_1 = require("./dk-culture");
const es_culture_1 = require("./es-culture");
const fi_culture_1 = require("./fi-culture");
const fr_culture_1 = require("./fr-culture");
const uk_culture_1 = require("./uk-culture");
const hk_culture_1 = require("./hk-culture");
const hu_culture_1 = require("./hu-culture");
const id_culture_1 = require("./id-culture");
const in_culture_1 = require("./in-culture");
const it_culture_1 = require("./it-culture");
const mx_culture_1 = require("./mx-culture");
const my_culture_1 = require("./my-culture");
const nl_culture_1 = require("./nl-culture");
const no_culture_1 = require("./no-culture");
const nz_culture_1 = require("./nz-culture");
const pe_culture_1 = require("./pe-culture");
const pt_culture_1 = require("./pt-culture");
const se_culture_1 = require("./se-culture");
const sg_culture_1 = require("./sg-culture");
const us_culture_1 = require("./us-culture");
const usme_culture_1 = require("./usme-culture");
const th_culture_1 = require("./th-culture");
exports.AllCultures = {
    "de-at": {
        "EUR": new at_culture_1.DeAtEur(),
        "USD": new at_culture_1.DeAtUsd()
    },
    "en-at": {
        "EUR": new at_culture_1.EnAtEur(),
        "USD": new at_culture_1.EnAtUsd()
    },
    "en-au": {
        "AUD": new au_culture_1.EnAuAud(),
        "USD": new au_culture_1.EnAuUsd()
    },
    "en-be": {
        "EUR": new be_culture_1.EnBeEur(),
        "USD": new be_culture_1.EnBeUsd()
    },
    "nl-be": {
        "EUR": new be_culture_1.NlBeEur(),
        "USD": new be_culture_1.NlBeUsd()
    },
    "fr-be": {
        "EUR": new be_culture_1.FrBeEur(),
        "USD": new be_culture_1.FrBeUsd()
    },
    "en-br": {
        "BRR": new br_culture_1.EnBrBrr(),
        "USD": new br_culture_1.EnBrUsd()
    },
    "pt-br": {
        "BRR": new br_culture_1.PtBrBrr(),
        "USD": new br_culture_1.PtBrUsd()
    },
    "en-ca": {
        "CAD": new ca_culture_1.EnCaCad(),
        "USD": new ca_culture_1.EnCaUsd()
    },
    "fr-ca": {
        "CAD": new ca_culture_1.FrCaCad(),
        "USD": new ca_culture_1.FrCaUsd()
    },
    "de-ch": {
        "CHF": new ch_culture_1.DeChChf(),
        "EUR": new ch_culture_1.DeChEur(),
        "USD": new ch_culture_1.DeChUsd(),
        "GBP": new ch_culture_1.DeChGbp()
    },
    "fr-ch": {
        "CHF": new ch_culture_1.FrChChf(),
        "EUR": new ch_culture_1.FrChEur(),
        "USD": new ch_culture_1.FrChUsd(),
        "GBP": new ch_culture_1.FrChGbp()
    },
    "it-ch": {
        "CHF": new ch_culture_1.ItChChf(),
        "EUR": new ch_culture_1.ItChEur(),
        "USD": new ch_culture_1.ItChUsd(),
        "GBP": new ch_culture_1.ItChGbp()
    },
    "en-ch": {
        "CHF": new ch_culture_1.EnChChf(),
        "EUR": new ch_culture_1.EnChEur(),
        "USD": new ch_culture_1.EnChUsd(),
        "GBP": new ch_culture_1.EnChGbp()
    },
    "es-cl": {
        "USD": new cl_culture_1.EsClUsd(),
        "CLP": new cl_culture_1.EsClClp()
    },
    "en-cl": {
        "USD": new cl_culture_1.EnClUsd()
    },
    "zh-cn": {
        "CNY": new cn_culture_1.ZhCnCny()
    },
    "en-cn": {
        "CNY": new cn_culture_1.EnCnCny()
    },
    "es-co": {
        "COP": new co_culture_1.EsCoCop(),
        "USD": new co_culture_1.EsCoUsd()
    },
    "de-de": {
        "EUR": new de_culture_1.DeDeEur(),
        "DKK": new de_culture_1.DeDeDkk(),
        "CZK": new de_culture_1.DeDeCzk(),
        "NOK": new de_culture_1.DeDeNok(),
        "PLN": new de_culture_1.DeDePln(),
        "USD": new de_culture_1.DeDeUsd()
    },
    "en-de": {
        "EUR": new de_culture_1.EnDeEur(),
        "DKK": new de_culture_1.EnDeDkk(),
        "CZK": new de_culture_1.EnDeCzk(),
        "NOK": new de_culture_1.EnDeNok(),
        "PLN": new de_culture_1.EnDePln(),
        "USD": new de_culture_1.EnDeUsd()
    },
    "en-dk": {
        "DKK": new dk_culture_1.EnDkDkk(),
        "USD": new dk_culture_1.EnDkUsd(),
        "EUR": new dk_culture_1.EnDkEur(),
        "SEK": new dk_culture_1.EnDkSek(),
        "NOK": new dk_culture_1.EnDkNok()
    },
    "es-es": {
        "EUR": new es_culture_1.EsEsEur(),
        "USD": new es_culture_1.EsEsUsd()
    },
    "en-es": {
        "EUR": new es_culture_1.EnEsEur(),
        "USD": new es_culture_1.EnEsUsd()
    },
    "pt-es": {
        "EUR": new es_culture_1.PtEsEur(),
        "USD": new es_culture_1.PtEsUsd()
    },
    "en-fi": {
        "EUR": new fi_culture_1.EnFiEur(),
        "USD": new fi_culture_1.EnFiUsd(),
        "SEK": new fi_culture_1.EnFiSek(),
        "DKK": new fi_culture_1.EnFiDkk(),
        "NOK": new fi_culture_1.EnFiNok()
    },
    "fr-fr": {
        "EUR": new fr_culture_1.FrFrEur(),
        "USD": new fr_culture_1.FrFrUsd()
    },
    "en-fr": {
        "EUR": new fr_culture_1.EnFrEur(),
        "USD": new fr_culture_1.EnFrUsd()
    },
    "en-gb": {
        "GBP": new uk_culture_1.EnGbGbp(),
        "EUR": new uk_culture_1.EnGbEur(),
        "USD": new uk_culture_1.EnGbUsd()
    },
    "en-hk": {
        "HKD": new hk_culture_1.EnHkHkd(),
        "USD": new hk_culture_1.EnHkUsd()
    },
    "hu-hu": {
        "HUF": new hu_culture_1.HuHuHuf(),
        "EUR": new hu_culture_1.HuHuEur(),
        "USD": new hu_culture_1.HuHuUsd()
    },
    "en-hu": {
        "HUF": new hu_culture_1.EnHuHuf(),
        "EUR": new hu_culture_1.EnHuEur(),
        "USD": new hu_culture_1.EnHuUsd()
    },
    "id-id": {
        "IDR": new id_culture_1.IdIdIdr()
    },
    "en-id": {
        "IDR": new id_culture_1.EnIdIdr()
    },
    "en-in": {
        "INR": new in_culture_1.EnInInr(),
        "USD": new in_culture_1.EnInUsd()
    },
    "hi-in": {
        "INR": new in_culture_1.HiInInr(),
        "USD": new in_culture_1.HiInUsd()
    },
    "it-it": {
        "EUR": new it_culture_1.ItItEur(),
        "USD": new it_culture_1.ItItUsd()
    },
    "en-it": {
        "EUR": new it_culture_1.EnItEur(),
        "USD": new it_culture_1.EnItUsd()
    },
    "es-mx": {
        "MXP": new mx_culture_1.EsMxMxp(),
        "MXN": new mx_culture_1.EsMxMxn(),
        "USD": new mx_culture_1.EsMxUsd()
    },
    "en-mx": {
        "MXP": new mx_culture_1.EnMxMxp(),
        "MXN": new mx_culture_1.EnMxMxn(),
        "USD": new mx_culture_1.EnMxUsd()
    },
    "en-my": {
        "MYR": new my_culture_1.EnMyMyr(),
        "USD": new my_culture_1.EnMyUsd()
    },
    "nl-nl": {
        "EUR": new nl_culture_1.NlNlEur(),
        "USD": new nl_culture_1.NlNlUsd()
    },
    "en-nl": {
        "EUR": new nl_culture_1.EnNlEur(),
        "USD": new nl_culture_1.EnNlUsd()
    },
    "en-no": {
        "EUR": new no_culture_1.EnNoEur(),
        "USD": new no_culture_1.EnNoUsd(),
        "SEK": new no_culture_1.EnNoSek(),
        "DKK": new no_culture_1.EnNoDkk(),
        "NOK": new no_culture_1.EnNoNok()
    },
    "en-nz": {
        "NZD": new nz_culture_1.EnNzNzd(),
        "USD": new nz_culture_1.EnNzUsd(),
        "AUD": new nz_culture_1.EnNzAud()
    },
    "es-pe": {
        "USD": new pe_culture_1.EsPeUsd(),
        "PEN": new pe_culture_1.EsPePen()
    },
    "en-pe": {
        "USD": new pe_culture_1.EnPeUsd(),
        "PEN": new pe_culture_1.EnPePen()
    },
    "pt-pt": {
        "EUR": new pt_culture_1.PtPtEur(),
        "USD": new pt_culture_1.PtPtUsd()
    },
    "en-pt": {
        "EUR": new pt_culture_1.EnPtEur(),
        "USD": new pt_culture_1.EnPtUsd()
    },
    "en-se": {
        "EUR": new se_culture_1.EnSeEur(),
        "SEK": new se_culture_1.EnSeSek(),
        "DKK": new se_culture_1.EnSeDkk(),
        "NOK": new se_culture_1.EnSeNok(),
        "USD": new se_culture_1.EnSeUsd()
    },
    "sv-se": {
        "EUR": new se_culture_1.SvSeEur(),
        "SEK": new se_culture_1.SvSeSek(),
        "DKK": new se_culture_1.SvSeDkk(),
        "NOK": new se_culture_1.SvSeNok(),
        "USD": new se_culture_1.SvSeUsd()
    },
    "se-se": {
        "SEK": new se_culture_1.SeSeSek(),
        "DKK": new se_culture_1.SeSeDkk(),
        "NOK": new se_culture_1.SeSeNok()
    },
    "en-sg": {
        "SGD": new sg_culture_1.EnSgSgd(),
        "USD": new sg_culture_1.EnSgUsd(),
        "EUR": new sg_culture_1.EnSgEur(),
        "JPY": new sg_culture_1.EnSgJpy()
    },
    "en-us": {
        "USD": new us_culture_1.EnUsUsd()
    },
    "en-usme": {
        "USD": new usme_culture_1.EnUsmeUsd()
    },
    "es-usme": {
        "USD": new usme_culture_1.EsUsmeUsd()
    },
    "en-th": {
        "THB": new th_culture_1.EnThThb()
    },
    "th-th": {
        "THB": new th_culture_1.ThThThb()
    }
};
